import { useEmbeddedPartner } from 'components/hooks/employer_onboarding/useEmbeddedPartner'
import ClickableExternalLink from 'components/reusable/ClickableExternalLink'
import LoadingSpinnerCentered from 'components/reusable/LoadingSpinnerCentered'
import { Modal } from 'slab'
import { formatPhoneNumber } from 'utils'
import { type PartnersPartner } from 'utils/web_api.schemas'

const SUPPORT_PAGE_LINK = 'https://support.thatch.com/all/onboarding'

const getContactMessage = (partner: PartnersPartner): React.ReactNode => {
  const supportEmail = partner.support_email
  const supportPhone = partner.support_phone_number

  if (supportEmail && supportPhone) {
    return (
      <>
        Email <a href={`mailto:${supportEmail}`}>{supportEmail}</a> or call {formatPhoneNumber(supportPhone)} with your questions.
      </>
    )
  }
  if (supportEmail) {
    return (
      <>
        Email <a href={`mailto:${supportEmail}`}>{supportEmail}</a> with your questions.
      </>
    )
  }
  if (supportPhone) {
    return <>Call {formatPhoneNumber(supportPhone)} with your questions.</>
  }
  // this should never happen, but just for type safety
  return <>Reach out to {partner.display_name} with your questions.</>
}
export function EmbeddedSupportLinkContent () {
  const { data: partner } = useEmbeddedPartner()

  const shouldShowPartnerSupport = partner && (partner.support_email || partner.support_phone_number)

  if (!partner) {
    // avoid flashing the no-support option when the model is loading
    return <Modal.Body><LoadingSpinnerCentered /></Modal.Body>
  }

  return (
    <Modal.Body>
      <div>
        <div className='pb-2'>
          {shouldShowPartnerSupport
            ? (
              <>
                <h3 className='body-bold mb-1'>Want to talk to someone{partner?.friendly_name && ` at ${partner.friendly_name}`}?</h3>
                <p>
                  {getContactMessage(partner)}
                </p>
              </>
              )
            : (
              <>
                <h3 className='body-bold mb-1'>Need help?</h3>
                <ClickableExternalLink
                  url={SUPPORT_PAGE_LINK}
                  label='Navigate to the Thatch support page:'
                />
              </>
              )}
        </div>
      </div>
    </Modal.Body>
  )
}
